var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CreatePicture"},[_c('b-row',[_c('Dropzone',{attrs:{"id":"dropzone","awss3":_vm.awss3,"options":_vm.dropzoneOptions},on:{"vdropzone-s3-upload-error":_vm.s3UploadError,"vdropzone-s3-upload-success":_vm.s3UploadSuccess,"vdropzone-success":_vm.dropzoneSuccess}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-423af5c0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CreatePicturePage.vue
// module id = null
// module chunks = 